import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let connection = useDataValue({
    context: 'connection',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'connection',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    // Get connection type from the app metadata
    let connectionType = connection?.app?.connection?.type

    switch (connectionType) {
      case 'API_TOKEN': {
        setFlowTo(normalizePath(props.viewPath, 'Reconnect/ApiToken'))
        return
      }

      case 'OAUTH2':
      case 'OAUTH2_AUTHORIZATION_CODE': {
        setFlowTo(normalizePath(props.viewPath, 'Reconnect/OAuth2'))
        return
      }

      case 'OAUTH2_CLIENT_CREDENTIALS': {
        submit({ type: 'connect-oauth2-client-credentials' })
        return
      }

      default: {
        return
      }
    }
  }
}
